<template>
    <div class="navBar-box">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="left-box">
                <router-link class="navbar-brand" to="/superiorStaffHome">
                    <div class="logo-box"><img class="logo-icon" src="../assets/img/logo1.png" /></div>
                </router-link>
            </div>
            <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="iconfont icon-caidan"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div></div>
                <div class="center-box">
                    <ul class="navbar-nav">
                        <li class="nav-item"><router-link :class="path == '/superiorStaffHome' ? 'nav-link active' : 'nav-link'" to="/superiorStaffHome">首页</router-link></li>
                        <li class="nav-item">
                            <router-link :class="path == '/superiorStaffBrand' ? 'nav-link active' : 'nav-link'" to="/superiorStaffBrand">品牌专区</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :class="path == '/superiorStaffService' ? 'nav-link active-y' : 'nav-link'" to="/superiorStaffService">服务市场</router-link>
                        </li>
                        <li class="nav-item"><router-link :class="path == '/about' ? 'nav-link active' : 'nav-link'" to="/about">关于数位</router-link></li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {
            path: ''
        };
    },
    created() {},
    mounted() {
        this.path = this.$route.path;
    },
    computed: {},
    methods: {},
    components: {},
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
@media screen and (max-width: 1024px) {
    .navBar-box {
        .navbar {
            width: 100% !important;
            padding: 0 10px !important;
            box-sizing: border-box;
            justify-content: space-between !important;
            padding: 8px 16px;
        }
    }
}
.navBar-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    .navbar {
        width: 85%;
        max-width: 1400px;
        height: 100%;
        min-height: 64px;
        background: none;
        font-size: 15px;
        color: #333;
        justify-content: center;
        padding-left: 0;
        padding-right: 0;

        .nav-link {
            color: #333;
            font-size: 16px;
            text-align: left;
        }

        .active {
            color: #2393ff;
        }

        .active-y {
            color: #2393ff;
        }

        .left-box {
            .logo-icon {
                width: 189px;
                height: 30px;
                object-fit: scale-down;

            }

            .logo {
                width: auto;
                height: 20px;
                margin-left: 15px;
                object-fit: scale-down;
            }
        }

        .navbar-toggler {
            .icon-caidan {
                color: #000;
                font-size: 22px;
            }
        }

        .collapse {
            // width: ;
            // display: flex;
            justify-content: flex-end;
            // align-items: center;
            // flex-wrap: wrap;
        }

        .collapse:not(.show) {
            display: none;
        }

        .center-box {
            // display: flex;
            // align-items: center;

            .nav-link {
                margin-right: 54px;
                padding-left: 0;
                padding-right: 0;
                // font-size: 15px;

                .arrow-down {
                    font-size: 14px;
                    margin-left: 4px;
                }
            }

            .nav-item:last-child {
                .nav-link {
                    margin-right: 0;
                }
            }

            .dropdown-toggle::after {
                display: none;
            }
        }

        .right-box {
            padding-right: 25px;
            display: flex;
            align-items: center;

            .query-icon {
                font-size: 24px;
                margin-right: 22px;
            }

            .el-dropdown-link {
                color: #333;
                display: flex;
                align-items: center;

                .text {
                    margin: 0 5px;
                }

                .el-icon-caret-bottom {
                    color: #888788;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
